import { useMsal } from '@azure/msal-react';
import { ActionButton, Icon, Link, Spinner, Stack, Text, useTheme } from "@fluentui/react";
import saveAs from 'file-saver';
import { AppLinkToExternal } from 'global/Application';
import { AppDataSource } from 'global/DataSources/AppDataSource';
import { MsalTokenSource } from 'global/DataSources/MsalTokenSource';
import Formatters from 'global/Utility/Formatters';
import { bcbs_groupconfigurationsnapshot } from 'model/CRM';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import styles from './Timeline.module.css';

interface IFile {
    versionId: string;
    downloaded: boolean;
}

interface ISnapshotTimelineProps {
    snapshot: bcbs_groupconfigurationsnapshot
}

const SnapshotTimeline: React.FunctionComponent<ISnapshotTimelineProps> = (props) => {
    const dispatch = useDispatch();
    // const state = useSelector((state: RootState) => state);
    const theme = useTheme();

    const history = useHistory();

    const { instance } = useMsal();

    const tokenSource = new MsalTokenSource(instance);
    const dataSource = new AppDataSource(tokenSource);

    const [files, setFiles] = useState<IFile[] | null>(null);

    useEffect(() => {
        (async () => {
            if (props?.snapshot.bcbs_filename) {
                const versions = await dataSource.getSnapshotVersions(props?.snapshot.bcbs_filename) as string[];

                const files = versions.map(t => {
                    const n: IFile = {
                        downloaded: false,
                        versionId: t,
                    };
                    return n;
                });

                setFiles(files);
            }
        })();
    }, [props?.snapshot?.bcbs_filename]);

    return <>
        {!files &&
            <Spinner styles={{ root: { margin: '25px' } }} />
        }
        {files &&
            <div className={styles.timeline}>
                <Text variant='large'>Timeline</Text>
                <ol className={styles.timeline_ol}>
                    {files?.map(eachFile => {
                        return <li
                            key={eachFile.versionId}
                            className={styles.timeline_li}
                        // style={{ border: state.data.snapshotVersionId === eachFile.versionId ? '2px solid red' : undefined }}

                        >
                            <Stack>
                                <Link
                                    onClick={() => {
                                        // dispatch(LoadSnapshotWithVersionAction(dataSource, history, eachFile.versionId))

                                        window.open(AppLinkToExternal({
                                            type: 'groupLibrary',
                                            id: [props.snapshot._bcbs_groupid_value!, props.snapshot.bcbs_groupconfigurationsnapshotid!, eachFile.versionId]
                                        }))

                                    }}
                                >
                                    {Formatters.ToShortDateTime(eachFile.versionId)}
                                </Link>
                                <ActionButton
                                    iconProps={{
                                        iconName: "Download",
                                        styles: { root: { fontSize: '12px', paddingLeft: '5px', cursor: 'pointer', color: theme.semanticColors.link } }
                                    }}
                                    onClick={async (event) => {
                                        event.stopPropagation();
                                        let result = await dataSource.downloadGroupConfigurationSnapshot(
                                            props?.snapshot,
                                            eachFile.versionId
                                        );
                                        const blob = new Blob([JSON.stringify(result?.json)], { type: 'text/plan;charset=utf-8' });
                                        saveAs(blob, `${props?.snapshot.bcbs_name}(${eachFile.versionId}).json`, { autoBom: true });
                                        setFiles(xFiles => {
                                            const files = xFiles?.map(eachXFile => {
                                                const file = { ...eachXFile };

                                                if (eachXFile === eachFile) {
                                                    file.downloaded = true;
                                                }

                                                return file
                                            })
                                            return files!;
                                        });

                                    }}
                                >
                                    Version : {eachFile.versionId}
                                    <Icon
                                        iconName="Copy"
                                        styles={{ root: { fontSize: '12px', paddingLeft: '5px', cursor: 'pointer' } }}
                                        onClick={() => navigator.clipboard.writeText(eachFile.versionId!)}
                                    />
                                </ActionButton>

                            </Stack>

                        </li>;
                    })}
                </ol>
            </div>
        }
    </>
}
export default SnapshotTimeline;